var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper page",attrs:{"id":"profile"}},[_c('h1',{staticClass:"title margin-bottom-55"},[_vm._v("Profile")]),_c('div',{attrs:{"id":"profile-content"}},[_c('profile-details'),_c('profile-password')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }